export const INSIDE_DRAWER = {
    admin: {
        service_name: "Administración",
        show_drawer: true,
        isOpen: false,
        route: "administracion?servicio=",
    },
    config: {
        service_name: "Configuración",
        show_drawer: true,
        isOpen: false,
        route: "configuracion?servicio=",
    },
    users: {
        service_name: "Usuarios",
        show_drawer: true,
        isOpen: false,
        route: "usuarios",
    },
};

export const Routes = {
    login: {
        route: "/login",
    },
    dashboard: {
        route: "/",
        wordKey: "Home",
        showMenuItem: true,
        needSuperAuth: false,
    },
    zonas: {
        route: "/zonas",
        wordKey: "Zonas",
        showMenuItem: true,
        needSuperAuth: false,
    },
    accesos: {
        route: "/accesos",
        wordKey: "Accesos",
        showMenuItem: true,
        needSuperAuth: false,
    },
    kioscos: {
        route: "/kioscos",
        wordKey: "TABs",
        showMenuItem: true,
        needSuperAuth: false,
    },
    kioscosDetail: {
        route: "/kioscos_detalle",
        wordKey: "Detalle de TABs",
        showMenuItem: false,
        needSuperAuth: false,
    },
    horarios: {
        route: "/horarios",
        wordKey: "Horarios",
        showMenuItem: true,
        needSuperAuth: false,
    },
    hoteles: {
        route: "/servicio/SFHOTEL/config/hoteles",
        wordKey: "Hoteles",
        showMenuItem: true,
        needSuperAuth: false,
    },
    vouchers: {
        route: "/servicio/SFHOTEL/config/vouchers",
        wordKey: "Vouchers",
        showMenuItem: true,
        needSuperAuth: false,
    },
    usuarios: {
        route: "/usuario",
        wordKey: "Usuarios",
        showMenuItem: true,
        needSuperAuth: false,
    },
    eventos: {
        route: "/eventos",
        wordKey: "Eventos",
        showMenuItem: false,
        needSuperAuth: false,
    },
    administracion: {
        route: "/administracion",
        wordKey: "Usuarios por Servicios",
        showMenuItem: false,
        needSuperAuth: false,
    },
    dashboardDatosPersonales: {
        route: "/administracion/dashboard-usuarios",
        wordKey: "Datos Personales",
        showMenuItem: false,
        needSuperAuth: false,
    },
    documentTable: {
        route: "/servicio/SIGN/admin/documents",
        wordKey: "Documentos",
        showMenuItem: false,
        needSuperAuth: false,
    },
    documentTypeTable: {
        route: "/servicio/SIGN/config/tipo_documento",
        wordKey: "Tipos De Documentos",
        showMenuItem: false,
        needSuperAuth: false,
    },
    migraTipoPasoTable: {
        route: "/servicio/RMIGRA/config/tipos_paso",
        wordKey: "Tipos de paso",
        showMenuItem: false,
        needSuperAuth: false,
    },
    migraPasoTable: {
        route: "/servicio/RMIGRA/config/pasos",
        wordKey: "Pasos",
        showMenuItem: false,
        needSuperAuth: false,
    },
    migraUsuarioPasoTable: {
        route: "/servicio/RMIGRA/admin/usuarios_pasos",
        wordKey: "Usuarios - Pasos",
        showMenuItem: false,
        needSuperAuth: false,
    },
    migraMonitorTable: {
        route: "/servicio/RMIGRA/admin/monitor",
        wordKey: "Monitor",
        showMenuItem: false,
        needSuperAuth: false,
    },
    migraVueloTable: {
        route: "/servicio/RMIGRA/admin/vuelos",
        wordKey: "Vuelos",
        showMenuItem: false,
        needSuperAuth: false,
    },
    /*
    pdfAnnotationEditor: {
        route: "/servicio/SIGN/admin/pdf_annotation",
        wordKey: "Editor de anotaciones PDF",
        showMenuItem: false,
        needSuperAuth: false,
    },
    */
    pdfAnnotationPublisher: {
        route: "/servicio/SIGN/admin/publicar",
        wordKey: "Publicar documento con anotaciones",
        showMenuItem: false,
        needSuperAuth: false,
    },
    sponsorship: {
        route: "/user-sponsorship",
        wordKey: "Sponsorship",
        showMenuItem: false,
        needSuperAuth: false,
    },
    usuariosXServicio: {
        route: "/usuarios-x-servicio",
        wordKey: "Usuarios",
        showMenuItem: false,
        needSuperAuth: false,
    },
    tipo_documento: {
        route: "/tipo_documento",
        wordKey: "Tipo de Documento",
        showMenuItem: true,
        needSuperAuth: false,
    },
    document: {
        route: "/documents",
        wordKey: "Documentos",
        showMenuItem: true,
        needSuperAuth: false,
    },
    usuariosAccesos: {
        route: "/servicio/HGATE/admin/usuarios",
        wordKey: "Usuarios - Accesos",
        showMenuItem: false,
        needSuperAuth: false,
    },
    monitorMia: {
        route: "/servicio/HGATE/admin/monitor",
        wordKey: "Monitor",
        showMenuItem: false,
        needSuperAuth: false,
    },
};

export const servicesRoutes = {
    IDBASE: [
        {
            route: "/usuarios",
            wordKey: "Usuarios",
            isGroup: false,
        }
    ],
    HGATE: [
        {
            route: "/config",
            wordKey: "Configuración",
            isGroup: true,
            routes: [
                {
                    route: "/zonas",
                    wordKey: "Zonas",
                    isGroup: false
                },
                {
                    route: "/accesos",
                    wordKey: "Accesos",
                    isGroup: false
                },
                {
                    route: "/kioscos",
                    wordKey: "TABs",
                    isGroup: false
                },
                {
                    route: "/horarios",
                    wordKey: "Horarios",
                    isGroup: false
                }
            ]
        },
        {
            route: "/admin",
            wordKey: "Administración",
            isGroup: true,
            routes: [
                {
                    route: "/eventos",
                    wordKey: "Eventos",
                    isGroup: false
                },
                {
                    route: "/usuarios",
                    wordKey: "Usuarios - Accesos",
                    isGroup: false
                },
                {
                    route: "/monitor",
                    wordKey: "Monitor",
                    isGroup: false
                }
            ],
        },
        {
            route: "/usuarios",
            wordKey: "Usuarios",
            isGroup: false,
        }
    ],
    SIGN: [
        {
            route: "/config",
            wordKey: "Configuración",
            isGroup: true,
            routes: [
                {
                    route: "/tipo_documento",
                    wordKey: "Tipo de Documento",
                    isGroup: false
                }
            ],
        }, {
            route: "/admin",
            wordKey: "Administración",
            isGroup: true,
            routes: [
                {
                    route: "/documents",
                    wordKey: "Documentos",
                    isGroup: false
                }/*,
                {
                    route: "/pdf_annotation",
                    wordKey: "Editor de anotaciones PDF",
                    isGroup: false
                }*/
            ],
        },
        {
            route: "/usuarios",
            wordKey: "Usuarios",
            isGroup: false,
        }
    ],
    LBM: [
        {
            route: "/usuarios",
            wordKey: "Usuarios",
            isGroup: false,
        }
    ],
    RMIGRA: [
        {
            route: "/config",
            wordKey: "Configuración",
            isGroup: true,
            routes: [
                {
                    route: "/tipos_paso",
                    wordKey: "Tipos de paso",
                    isGroup: false,
                },
                {
                    route: "/pasos",
                    wordKey: "Pasos",
                    isGroup: false,
                },
            ],
        }, {
            route: "/admin",
            wordKey: "Administración",
            isGroup: true,
            routes: [
                {
                    route: "/usuarios_pasos",
                    wordKey: "Usuarios - Pasos",
                    isGroup: false,
                },
                {
                    route: "/monitor",
                    wordKey: "Monitor",
                    isGroup: false,
                },
                /*
                {
                    route: "/vuelos",
                    wordKey: "Vuelos",
                    isGroup: false,
                }
                */
            ],
        },
        {
            route: "/usuarios",
            wordKey: "Usuarios",
            isGroup: false,
        }
    ],
    SFHOTEL: [
        {
            route: "/config",
            wordKey: "Configuración",
            isGroup: true,
            routes: [
                {
                    route: "/hoteles",
                    wordKey: "Hoteles",
                    isGroup: false,
                },
                {
                    route: "/vouchers",
                    wordKey: "Vouchers",
                    isGroup: false,
                }
            ],
        },
        {
            route: "/usuarios",
            wordKey: "Usuarios",
            isGroup: false,
        }
    ]
}
